"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _Login = _interopRequireDefault(require("./pages/Login"));
var _Activate = _interopRequireDefault(require("./pages/Activate"));
var _Reset = _interopRequireDefault(require("./pages/Reset"));
var _clever = _interopRequireDefault(require("./pages/SSOError/clever.js"));
var _classlink = _interopRequireDefault(require("./pages/SSOError/classlink.js"));
var _Profile = _interopRequireDefault(require("./pages/Profile"));
var _Forgot = _interopRequireDefault(require("./pages/Forgot"));
var _ForgotUsername = _interopRequireDefault(require("./pages/ForgotUsername"));
var _Password = _interopRequireDefault(require("./pages/Password"));
var _RegistrationSurvey = _interopRequireDefault(require("./pages/RegistrationSurvey"));
var _Alerts = _interopRequireDefault(require("./pages/Alerts"));
var _SelfRoster = _interopRequireDefault(require("./pages/SelfRoster"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;
var Root = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Root, _React$Component);
  function Root() {
    _classCallCheck(this, Root);
    return _callSuper(this, Root, arguments);
  }
  _createClass(Root, [{
    key: "render",
    value: function render() {
      var forgotUsername = (0, _get2["default"])(Fortress, 'settings.config.username.forgot_username', false);
      var _this$props = this.props,
        match = _this$props.match,
        defaultLayout = _this$props.defaultLayout,
        registrationSurveyLayout = _this$props.registrationSurveyLayout,
        _this$props$enableSel = _this$props.enableSelfRoster,
        enableSelfRoster = _this$props$enableSel === void 0 ? false : _this$props$enableSel,
        selfRosterProps = _this$props.selfRosterProps;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/alerts"),
        component: _Alerts["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/login"),
        component: _Login["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/cleverError"),
        component: _clever["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/classlinkError"),
        component: _classlink["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/activate/:activationToken"),
        component: _Activate["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/reset/:resetToken"),
        component: _Reset["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/profile/:pawnId?/:pawnHash?"),
        component: _Profile["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/updatePassword/:pawnId?/:pawnHash?"),
        component: _Password["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/forgot"),
        component: _Forgot["default"],
        layout: defaultLayout
      }), forgotUsername && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/forgotUsername"),
        component: _ForgotUsername["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/registrationSurvey"),
        component: _RegistrationSurvey["default"],
        layout: registrationSurveyLayout
      }), enableSelfRoster && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        exact: true,
        path: "".concat(match.url, "/register/:hash"),
        component: _SelfRoster["default"],
        componentProps: selfRosterProps,
        layout: defaultLayout
      }));
    }
  }]);
  return Root;
}(_react["default"].Component);
_defineProperty(Root, "propTypes", {
  match: _propTypes["default"].object,
  /*
   *   To use below props via <AppRoute /> in routes.js,
   *   you may need to set layout={null} so that there
   *   is not a layout within a layout
   */
  defaultLayout: _propTypes["default"].func,
  // component
  registrationSurveyLayout: _propTypes["default"].func,
  // component
  enableSelfRoster: _propTypes["default"].bool,
  selfRosterProps: _propTypes["default"].object
});